import { Row, SortingFns } from '@tanstack/react-table';
import { compareVersions } from '@upright/common/utils';

// When adding a new custom sorting function, you first need to add it to the interface in table-v2/types.ts
// TODO: add string sorting function that takes into account diacritics. E.g. Électricité de France treated as Electricite de France.

export const customSortingFns: SortingFns = {
  // Custom sorting function here that handles the number case with NaNs
  numberOrNaN: (rowA: Row<unknown>, rowB: Row<unknown>, columnId: string) => {
    const a: number = rowA.getValue(columnId);
    const b: number = rowB.getValue(columnId);
    return a - b || Number(isNaN(b)) - Number(isNaN(a));
  },
  version: (rowA: Row<unknown>, rowB: Row<unknown>, columnId: string) => {
    const a: string = rowA.getValue(columnId);
    const b: string = rowB.getValue(columnId);
    return compareVersions(a, b);
  },
} as const;
